import React, { useEffect, useState } from "react";
import { Loader2, Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/admin/AdminUI";
import { Badge } from "@/components/ui/badge";

function fmt(ts) {
  try {
    return new Date(ts).toLocaleString();
  } catch {
    return ts;
  }
}

export default function AdminDeleted() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/admin/deleted").then((r) => setItems(r.data)).catch(() => setItems(false));
  }, []);

  if (items === null)
    return <div className="flex h-64 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>;
  if (items === false) return <p className="text-sm text-destructive">Failed to load.</p>;

  return (
    <div data-testid="admin-deleted">
      <PageHeader title="Recently Deleted" subtitle="Audit trail of soft-deleted records. Restore is not available from this screen." />
      {items.length === 0 ? (
        <div className="flex min-h-[240px] flex-col items-center justify-center rounded-2xl border-2 border-dashed border-border/60 bg-card/40 text-center">
          <Trash2 className="h-8 w-8 text-muted-foreground" />
          <p className="mt-3 font-display font-bold">Nothing deleted recently</p>
        </div>
      ) : (
        <div className="space-y-3" data-testid="deleted-list">
          {items.map((it, i) => (
            <div key={i} className="flex items-center justify-between rounded-xl border border-border bg-card p-4" data-testid={`deleted-row-${i}`}>
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-destructive/10 text-destructive">
                  <Trash2 className="h-5 w-5" />
                </div>
                <div>
                  <p className="font-medium">{it.label}</p>
                  <div className="text-xs text-muted-foreground">
                    <Badge variant="outline" className="mr-2 font-mono text-[10px]">{it.type}</Badge>
                    {it.user_email} · {fmt(it.deleted_at)}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
